import { AbstractModel } from '@/models/abstractModel';
import type { ILeagueApi } from '@/types/league';

export class LeagueItem extends AbstractModel {
    public customLeagueId: number | null = null;
    public customLeagueName: string | null = null;
    public gamesCount: number = 0;
    public id: number = 0;
    public internalId: string = '';
    public name: string = '';
    public sportId: number = 0;

    constructor(data?: ILeagueApi) {
        super();

        if (!data) {
            return;
        }

        this.id = data.id;
        this.internalId = data.internal_id;
        this.customLeagueId = data.custom_league_id;
        this.customLeagueName = data.custom_league_name;
        this.gamesCount = data.games_count;
        this.name = data.name;
        this.sportId = data.sport_id;
    }

    get customLeagueDisplay(): string {
        if (!this.hasCustomLeagueAssociation) {
            return '';
        }

        if (this.customLeagueName) {
            return `${this.customLeagueName} (${this.customLeagueId})`;
        }

        return String(this.customLeagueId);
    }

    get hasCustomLeagueAssociation(): boolean {
        return this.customLeagueId != null;
    }
}
